//messages.js
export default {

  record: "Grabar",
  cancel: "Cancelar",
  next: "Siguiente",
  before: "Anterior",
  save: "Guardar",
  open: "Abrir",
  back: "Regresar",
  refuse: "Rechazar",
  approve: "Aprobar",
  visualize: "Visualizar",
  generateExcel: "Generar Excel",
  generatePDF: "Generar PDF",
  ok: "Ok",
  observations: "Observaciones",
  date: "Fecha",
  bill: "Factura",
  agent: "Agente",
  branch: "Sucursal",
  status: "Estado",
  list: "Listado",
  create: "Crear",
  search: "Buscar",
  generate: "Generar",
  startDate: "Inicio",
  endDate: "Fin",
  total: "Total",
  value: "Valor Total",
  statistics: "Estadísticas",

  reference: "Referencia",
  number: "Número",
  rowsByPage: "Registros por página",
  of: "de",
  sendDate: "Fecha de envío",
  title: "Título",
  imagenLocal: "Imagen en el equipo",
  fileLocal: "Archivo adjunto",
  imagenUrl: "Url de la imagen",
  attachementHint: "Fichero máximo 2 MB",

  // SIDEBAR
  Modules: "Módulos",
  administration: "Administración",
  notifications: "Notificaciones",

  noOrderEmission: "N° EMI",

  orderEmissionListCotizationDate: "Registro (T1)",
  orderEmissionListCoordinationDate: "Coordinación (T2)",
  orderEmissionListInspectionDate: "Inspección (T3)",
  orderEmissionListEmissionDate: "Emisión (T4)",
  orderEmissionListFileDeliveryDate: "Entrega Archivo (T5)",
  orderEmissionListCustomerDeliveryDate: "Entrega Cliente (T6)",

  statePolicy: "Estado póliza",
  seeInspections: "Ver inspecciones",


  electronicDocumentReferenceId: "Id Referencia",
  electronicDocumentCodigo: "Código",
  electronicDocumentIdentification: "Identificación",
  electronicDocumentClientName: "Cliente",
  electronicDocumentEmail: "Correo electrónico",
  electronicDocumentDocumentType: "Tipo Documento",
  electronicDocumentOrderNumber: "N° EMI",
  electronicDocumentTotalDocuments: "N° Docs",
  electronicDocumentModificationDate: "Fecha Modificación",
  electronicDocumentFvcStatus: "Estado FVC",
  electronicDocumentSignStatus: "Estado Póliza",
  electronicDocumentActions: "Acciones",


  users: "Usuarios",
  preferences: "Preferencias",
  orderEmission: "Orden de emisión",
  newRiskCar: "Vehículos(Riesgo Nuevo)",
  renovationCar: "Vehículos(Renovación)",
  newRiskGeneral: "Ramos Generales(Riesgo Nuevo)",
  renovationGeneral: "Ramos Generales(Renovación)",
  otherMov: "Otros Movimientos",
  bouquetDetailToEmit: "Ramos a Emitir",
  isProductClose:"¿Es producto cerrado?", 
  emisionType:"Tipo de Emisión", 
  comissions: "Comisiones",
  cotizadorFianzas: "Fianzas",
  liquidation: "Liquidación",
  preliquidation: "Preliquidación",
  ramo: "Ramo",
  preliquidationApproval: "Aprobación de Preliquidaciones",
  liquidationQuery: "Consulta de Liquidaciones",
  liquidationComission: "Reporte Liquidación Comisiones",
  squareComission: "Reporte Cuadre Comisiones",
  bonusProduction: "Bonos por Producción",
  preliquidationGeneration: "Generación de Preliquidación",
  bonusCompliance: "Bonos por Cumplimiento",
  bonusCategory: "Bonos por Categoría",
  cartera: "Cartera",
  reunionCartera: "Reunión con Cartera",
  images: "Imágenes",
  image: "Imagen",
  quoting: "Cotizadores",
  comercial: "Comercial",
  weeklyBudgetCompliance: "Cumplimiento de Presupuesto",
  clientPareto: "Pareto de Cliente",
  bonosNuevoRiesgo: "Bonos Nuevo Riesgo",
  presupuestoRenovacionBonos: "Presupuesto Renovación para Bonos",
  graphAnalysisofRenovations: "Gráfico Análisis de Renovaciones",
  accidentChart: "Gráfico de Siniestralidad",
  requestInspection: "Solicitud de Inspecciones",
  electronicDocuments: "Firma Electrónica",
  electronicBillings: "Comprobantes Electrónicos",
  productionReports: "Producción",
  preliquidationQuery: "Consulta de Preliquidaciones",

  branchOffices: "Sucursales",
  typeProduction: "Tipos de Producción",
  yearCommercial: "Año Comercial",
  lineBusiness: "Linea de Negocio",
  firstYear: "Primer Año",
  secondYear: "Segundo Año",
  //COMMISSIONS
  agency: "Sucursal",
  type: "Tipo",
  document: "Documento",
  bunch: "Ramo",
  policy: "Póliza",
  certificate: "Certificado",
  product: "Producto",
  endorsement: "Endoso",
  numFee: "Num. Cuota",
  paymentDate: "F/Pago",
  clientName: "Nombre de Cliente",
  premiumValue: "Valor Prima",
  commission: "Comisión",
  policies: "Políticas",
  generateLiquidation: "Generar Liquidación",
  noPreliquidations: "No existen preliquidaciones",
  noOrderEmissions: "No existen órdenes de emisión",
  noSquareComission: "No existen cuadre comisiones",
  noElectronicDocuments: "No existen Documentos Electrónicos",

  toPay: "A Pagar",

  movementType: "Tipo de movimiento",
  bonusType: "Tipo de Bono",
  Agency: "Sucursal",
  businessLine: "Línea de Negocio", //
  businessYear: "Año Comercial",
  businessWeek: 'Semana Comercial',
  totalIncome: "Ingreso Total",
  efficientIncome: "Ingreso Eficiente",
  budgetN1: "Presupuesto N1",
  bonusValueN1: "Valor Bono N1",
  budgetN2: "Presupuesto N2",
  bonusValueN2: "Valor Bono N2",


  //categoria 

  dateCreation: "Fecha Creación",
  yearMonth: "Año / Mes",
  category: "Categoría",
  primaNeta: "Prima Neta",
  quarter: "Trimestre",
  percentageBonus: "Porcentaje Bono",
  valueBonus: "Valor Bono",
  accidentRate: "Siniestralidad",
  
  


  preliquidacionNumber: "Número de Preliquidación",
  generateValue: "Valor Generado",

  orderEmisionType: "Tipo de orden de Emisión",
  commissionType: "Tipo de Comisión",
  system: "Sistema",

  noUsers: "No Existen Usuarios",

  indicator: "Indicador",
  percentPareto: "Porcentaje Pareto",
  businessYearIncome: "Ingreso Año Comercial",

  tableAccidentRate: "Tabla Siniestralidad",
  accumulatedQualifiedPremium: "Prima Calificada Acumulada",
  accumulatedPaidLosses: "Siniestros Pagados Acumulados",
  difference: "Diferencia",
  accidentRate: "Siniestralidad",


  analysisRenovations: "Tabla Análisis de Renovaciones",
  expected: "Esperado",
  renovated: "Renovado",
  percentRenovated: "% Renovado",
  paidOut: "Pagado",
  percentPaidOut: "% Pagado",

  sectionDetailsLines: "Sección Detalle de Líneas",
  sessionDetailsWeek: "Sección Detalle por Semana",
  startWeek: "Semana de Inicio",
  endWeek: "Semana de Fin",
  week: "Semana",
  budgetNumber: "Presupuesto(#)",
  issuedNumber: "Producción(#)",
  issuedPercent: "Producción(%)",
  commercialIncomeNumber: "Ing. Comercial (#)",
  commercialIncomePercent: "Ing. Comercial (%)",
  businessCompanyIncomeNumber: "Ing. Efi Comer. (#)",
  businessCompanyIncomePercent: "Ing. Efi Comer. (%)",

  //NOTIFICATIONS
  noRecords: "No existen registros",
  noNotifications: "No existen notificaciones",
  confirmRemoveNotification: "Desea eliminar la notificación",

  //EMISION ORDER
  apsHeader: "Datos del APS",
  aps: "APS",
  apsEmail: "Correo electrónico del APS",
  apsVendorIdentification: "Identificación Contacto Vendedor",
  apsVendorNames: "Contacto Vendedor",

  applicantHeader: "Datos del Solicitante",

  typePerson: "Tipo de Contribuyente",
  typeIdentification: "Tipo de Identificación",
  applicantTypeIdentification :  "Tipo de Identificación",
  identification: "Identificación",
  clientIdentification: "Identificación Cliente",

  province: "Provincia",
  city: "Cantón / Ciudad",
  mainStreet: "Calle principal",
  secundaryStreet: "Calle secundaria",
  telephone: "Teléfono fijo",
  telephoneOnly: "Teléfono",
  mobilePhone: "Teléfono celular",

  massive: "Masivos",
  individuals: "Individuales",
  guarantee: "Garantías",
  publicAccounts: "Cuentas Públicas",
  corporate: "Corporativo",
  People: "Personas",
  sureties: "Fianzas",
  Ifis: "Ifis",
  Automotive: "Automotríz",
  reasonSocial: "Razón social",
  birthDate: "Fecha de nacimiento",
  civilStatus: "Estado civil",
  gender: "Género",
  

  insuredHeader: "Datos del asegurado",
  insured: "Asegurado",
  

  emissionDetailHeader: "Detalles de emisión",

  validSince: "Vigencia desde",
  validUntil: "Vigencia hasta",

  paymentType: "Tipo de pago",
  paymentTypeOrder: "Tipo de pago de la orden",
  paymentMethod: "Forma de pago",
  quota: "Cuotas",
  collectPromissoryNoteWithBankDebit: "¿Desea cobrar el pagaré con débito bancario?",

  sendToEmailLinkWeb: "Formulario de vinculación se enviará a:",
  policySendToEmail: "Póliza electrónica se enviará a:",
  orderEmissionNote: "* Por favor, revisar bien todos los datos antes del registro de la emisión. El error o falta de información puede generar retrasos en tus requerimientos.",
  orderEmissionNoteUpdateInfo: "Registre teléfonos y correo electrónico en caso de requerir actualización",

  withPlate: "Vehículo cuenta con placa?",
  vehicleBrand: "Marca del vehículo",
  vehicleModel: "Modelo del vehículo",
  typeCoverage: "Tipo de cobertura",
  infoPersonAsured: "Información persona asegurada",
  dataSameApplicant: "Los mismos que los del solicitante",
  licensePlate: "Número de placa",
  policyNumber: "Número de póliza",
  emissionDetail: "Detalles de Emisión",
  assuredValueTotal: "Valor asegurado total",
  requiredInspection: "El vehículo requiere inspección?",
  requiredInspectionGeneral: "Requiere inspección?",
  assuredValueHelmet: "Valor asegurado casco",
  extraValue: "Valor extra",
  autototal: "Autotal",
  year: "Año",
  inspectionHeader: "Datos de contacto para la inspección",
  numberPolicy: 'Número de Póliza',
  emisionDetail: "Detalles de Emisión",
  invoice :"No.Factura",



  names: "Nombre(s)",
  surnames: "Apellidos(s)",
  sidebarTitle: "Oficina Virtual APS",
  stateFvc: "Estado formulario de vinculación",
  vigencyDateFvc: "Fecha fin de vigencia formulario de vinculación",

  // autentication
  loginTitle: "Oficina virtual para el APS",
  loginInfo: "Introduzca su usuario y contraseña para iniciar",
  enterEmailForResetPassword: "Ingrese su email para reestablecer su contraseña.",
  start: "Iniciar",
  keepSession: "Mantener sesión",
  password: "Contraseña",
  newPassword: "Nueva contraseña",
  confirmPassword: "Confirmar contraseña",
  forgotPassword: "Olvidé mi contraseña",
  resetPassword: "Reiniciar mi contraseña",
  requiredPassword: "Contraseña obligatoria",
  pleaseEnterYourPasswordToReset: "Por favor ingrese su nueva contraseña",
  invalidEmail: "Correo electrónico inválido",
  requiredEmail: "Correo electrónico obligatorio",
  email: "Correo electrónico",
  emailApplicant: "Correo electrónico (A este correo se enviará el PIN para la firma electrónica)",
  SendEmail: "Enviar correo electrónico",
  backToSignIn: "Regresar al inicio",
  publish: "Publicar",
  description: "Descripción",
  newNotification: "Nueva Notificación",

  // VALIDATIONS
  "Validation error": "Error de validación",
  '"title" is required': "El titulo es requerido",
  '"description" is required': "La descripción es requerida",
  'Notification exist with image url provided': "Existe una notificación con la url de imagen especificada",
  'Error sending notification': 'Error enviando la notificación',
  '"imageUrl" must be a valid uri with a scheme matching the http|https pattern': "La url de la imagen no es válida",
  '"imageUrl" is not allowed to be empty': "La imagen es requerida",

  "No exist preliquidation to generate": "No existen preliquidaciones para generar",

  //ASESUR API
  "Error access asesur token": "Error accediendo al token del api rest asegsur",
  "Some commission id not exist": "Algún identificador de las comisiones a aprobar no existe",
  "Some commission approval has unknown error": "Error desconocido aprobando las preliquidaciones",
  "Commissions preliquidation approval": "Aprobación de preliquidación satisfactoriamente",
  "Some commission reject has unknown error": "Error desconocido rechazando las preliquidaciones",
  "Commissions preliquidation reject": "Rechazada las preliquidaciones de comisiones",
  "Could not get commission liquidation info": "No se pudo obtener las liquidaciones de comisiones",
  "Could not get bonus Production pending info": "No se pudo obtener los bonos por producción pendientes",
  "Some bonus approval has unknown error": "Ha ocurrido un error aprobando los bonos",
  "Some bonus compliance approve and bill has unknown error": "Ha ocurrido un error desconocido aprobado y facturando",
  "Some bonusProduction approval has unknown error": "Ha ocurrido un error desconocido aprobando",
  "Bonus production preliquidation approval": "Aprobado los bonos por producción correctamente",
  "Preliquidation generation successfully": "Generación de preliquidación correctamente.",
  "Bonus preliquidation approval": "Aprobado los bonos correctamente",
  "Bonus production preliquidation reject": "Bonos por producción preliquidados han sido rechazados",
  "Some bonusProduction reject has unknown error": "Ha ocurrido un error desconodido rechazando",
  "Some bonusProduction id not exist": "Algunos ID's de bonos por producción no existen",
  //Category
  "Could not get bonus Category pending info": "No se pudo obtener los bonos por Categoria pendientes",
  "Some bonusCategory approval has unknown error": "Ha ocurrido un error desconocido aprobando",
  "Bonus Category preliquidation approval": "Aprobado los bonos por Categoria correctamente",
  "Bonus preliquidation approval": "Aprobado los bonos correctamente",
  "Bonus category preliquidation reject": "Bonos por Categoria preliquidados han sido rechazados",
  "Some bonusCategory reject has unknown error": "Ha ocurrido un error desconodido rechazando",
  "Some bonusCategory id not exist": "Algunos ID's de bonos por Categoria no existen",
  //IAM Errors
  "Failed profile update": "Error! Fallo la actualización del perfil del usuario.",
  //Tables
  accumulatedBudgetNumber: "Presupuesto Acumulado (#)",
  percent: "Porcentaje",
  broker: "Broker",
  listFirtClients: "Listado de los primeros",
  listLastClients: "Listado de los últimos",
  clients: "clientes",
  userID: "Id usuario",
  trademark: "Nombre comercial",
  typeUser: "Tipo de usuario",
  personType: "Tipo de usuario",
  firstName: "Primer nombre",
  secondName: "Segundo nombre",
  firstSurname: "Primer apellido",
  secondSurname: "Segundo apellido",
  constitutionDate: "Fecha de constitución",
  nationality: "Nacionalidad",
  country: "País",
  canton: "Cantón",
  onlyCity: "Ciudad",
  parish: "Parroquia",
  homeAddress: "Dirección domiciliaria",
  officeAddress: "Dirección oficina",
  emailNotification: "Email notificaciones",
  emailBilling: "Email facturación",
  emailOffice: "Email oficina",
  personalEmail: "Email personal",
  officePhone: "Teléfono oficina",
  homePhone: "Teléfono domicilio",
  webPage: "Página web",
  postalCode: "Código postal",
  accreditationDate: "Fecha de acreditación",
  insititutionCode: "Código de Institución",
  userSIAERP: "Usuario SIAERP",
  idVisualTime: "Id Visual Times",
  executives: "Ejecutivos",
  agencies: "Agencias",
  legalRepresentative: "Representante legal",
  emailRegister: "Email",
  socialReason: "Razon social",
  legal: "Representante legal",
  loan: "Préstamo",
  messageLocation: "Su orden de emisión se direccionará a ",
  confirmDialogMessage: "¿Desea continuar?",
  //Formularios de vinculación
  linkForms: "Formularios de Vinculación",
  noLinkForms: "No existen Fomularios de Vinculación",
  datePreliquidation: "Fecha Creación",
  Siniestralidad: "Siniestralidad",
};